<template>
  <div>
    <div class="wrapper-section">
      <div class="step step-2">
        <div class="step__title step-2__title">Отлично!<br>Осталось ответить на&nbsp;пару&nbsp;вопросов</div>
        <div class="step__subtitle">Укажите Ваши данные</div>
        <form class="step-2__form" autocomplete="off">
          <RadioGroup class="step-2__form-field"  name="type" v-model="form.type" :values="['ИП', 'Юр. лицо']" title="Статус страхователя" :required="required.type"/>
          <TextInput class="step-2__form-field" @correct="fieldAction('name')" name="name" v-model="form.name" placeholder="Название организации" :required="required.name"/>
          <TextInput class="step-2__form-field" @correct="fieldAction('INN')" @error="errors.INN = $event" name="INN" v-model="form.INN" mask="############" placeholder="ИНН" :required="required.INN" :regex="new RegExp(/^[0-9]{10}$|^[0-9]{12}$/)" tooltip="10 или 12 цифр"/>
          <TextInput class="step-2__form-field" @correct="fieldAction('email')" @error="errors.email = $event" type="text" name="email" v-model="form.email" :regex="new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)" tooltip="некорректный email" placeholder="E-mail" :required="required.email"/>
          <TextInput class="step-2__form-field" @correct="fieldAction('tel')" @error="errors.tel = $event" name="tel" type="tel" mask="+7 (###) ###-##-##" focusstring="+7 (" :regex="new RegExp(/\+7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}/)" tooltip="заполните поле" v-model="form.tel" placeholder="Номер телефона" :required="required.tel"/>
          <TextInput class="step-2__form-field" @correct="fieldAction('site')" @error="errors.site = $event" name="site" tooltip="некорректный адрес" v-model="form.site" focusstring="https://" placeholder="Адрес сайта" :required="required.site"/>
        </form>
        <Btn class="step__button step-2__button" :disabled="!formfilled" @click="toNextStep">Далее</Btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Btn from './Btn.vue'
import TextInput from './inputs/TextInput.vue'
import RadioGroup from './inputs/RadioGroup.vue'
export default {
  components: { RadioGroup, Btn, TextInput },
  data: ()=>({
    actions: {}
  }),
  methods: {
    fieldAction(name) {
      if (!this.actions[name]) {
        this.actions[name] = true
        this.$store.dispatch('callAction',name)
      }
    },
    async toNextStep(){
      let ok = await this.$store.dispatch('sendData')
      if (!ok) return
      if (!this.actions.step3) {
        this.actions.step3 = true
        this.$store.dispatch('callAction','step3')
      }
      this.$store.dispatch('nextStep')
    }
  },
  computed: {
    ...mapState(['form', 'required', 'errors']),
    ...mapGetters(['formfilled'])
  },
  watch: {
    'form.type':function(v){
      if (v && !this.actions.type) {
        this.actions.type = true
        this.$store.dispatch('callAction','type')
      }
    }
  }
}
</script>

<style lang="sass">
.step
  &-2
    &__title
      margin-bottom: 23px
    &__form
      display: block
      width: 604px
      max-width: 100%
      margin: 0 auto
      &-field
        &:not(:last-child)
          margin-bottom: 33px
          @include for-mob
            margin-bottom: 8px
    &__button
      margin-top: 63px
      @include for-mob
        margin-top: 32px
  &__subtitle
    font-size: 24px
    line-height: 1.16
    color: colors.$gray3
    text-align: center
    margin-bottom: 70px
    @include mobFont(16, 24)
    @include for-mob
      margin-bottom: 16px
</style>